export default __webpack_public_path__ + "static/media/eatingtimes_1.611ca1d6.jpg";